// Format angka step jadi "ribu"/"juta" supaya lebih ringkas di UI.
// Contoh: 999 -> "999", 10000 -> "10 ribu", 12500 -> "12,5 ribu", 2000000 -> "2 juta"
const formatNumberCompact = (value) => {
  const num = Number(value);

  // Fallback aman kalau step null/undefined/NaN
  if (!Number.isFinite(num)) return String(value ?? '');

  const abs = Math.abs(num);

  // Helper formatter: pakai locale id-ID + max 1 decimal, lalu hilangkan ",0"
  const formatWithMax1Decimal = (n) => {
    const formatted = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 1 }).format(n);
    return formatted.replace(/,0$/, '');
  };

  if (abs >= 1_000_000) {
    return `${formatWithMax1Decimal(num / 1_000_000)} juta`;
  }

  if (abs >= 1_000) {
    return `${formatWithMax1Decimal(num / 1_000)} ribu`;
  }

  return new Intl.NumberFormat('id-ID').format(num);
};

export default formatNumberCompact;